// extracted by mini-css-extract-plugin
export var audioPlayer = "_og-0";